<template>
  <div
    ref="autosuggest"
    class="fields-auto-suggest w-full md:w-80 relative"
  >
    <fieldset class="formulate-form ">
      <FormulateInput
        v-model="userInput"
        type="text"
        :name="name"
        :placeholder="placeholder"
        :label="label"
        autocomplete="off"
        class="formulate-input h-14"
        :element-class="(context, classes) => [{'has-autosuggestions': showAutoSuggestions}, 'auto-suggestion-field'].concat(classes) "
        @focus="showSuggestions"
        @blur="blurInput"
      />
    </fieldset>
    <div
      v-show="showAutoSuggestions"
      class="auto-suggest-box"
    >
      <ul @mouse-over="enableSuggestions">
        <li
          v-for="option, index in options"
          :key="index"
        >
          <button
            class="suggestion-item text-black text-left w-full h-full"
            @keyup.enter="selectSuggestion(option)"
            @click.prevent="selectSuggestion(option)"
          >
            {{ option.name }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "FieldsAutoSuggest",
  props: {
    suggestionList: {
      type: Array,
      default: () => []
    },
    minChars: {
      type: Number,
      default: 1
    },
    i18n: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    initialValue: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      showAutoSuggestions: false,
      userInput: '',
    }
  },
  computed: {
    options() {
      const lowerCasedInput = this.userInput.toLowerCase()
      return this.suggestionList.filter(item => {
          const name = item.name?.toLowerCase()
          if (!name) return false
          return name.includes(lowerCasedInput)
        }) || []
    }
  },
  watch: {
    userInput(newVal, oldVal) {
      // empty emit on clearing input to remove current values / disable (dependant) secondary fields (eg. country -> schools)
      if (!newVal && oldVal) {
        this.resetSuggestion()
      }
    }
  },
  created() {
    this.userInput = this.initialValue || '';

    // When prefilled data is available on init... Select first matched part
    if (this.name === 'city' && this.initialValue && this.options.length) {
      this.selectSuggestion(this.options[0]);
    }
  },
  methods: {
    showSuggestions() {
      this.showAutoSuggestions = true;
    },

    hideSuggestions() {
      this.showAutoSuggestions = false;
    },

    enableSuggestions() {
      this.showSuggestions();
    },

    resetSuggestion() {
      this.$emit('reset-suggestion');
      this.userInput = ''
    },

    selectSuggestion(option) {
      this.$emit('select-suggestion', option);
      this.userInput = option.name;
      this.hideSuggestions();
    },

    blurInput() {
      setTimeout(() => {
        this.hideSuggestions();
      }, 250);
    },
  }
}
</script>
<style lang="postcss">
.fields-auto-suggest {


 .auto-suggest-box {
  @apply rounded-b-lg bg-white border border-gray-100 border-t-0 border-opacity-30 absolute left-0 top-12 z-10 p-4 w-full max-h-32 overflow-y-scroll;
  scrollbar-width: none;
  li {
    @apply font-medium text-gray-100
  }

  li:hover {
    @apply text-primary-bravo
  }
  &::-webkit-scrollbar {
    @apply rounded;
    width: 6px;
    height: 0px;
    overflow: hidden;

  &-track {
    @apply rounded;
  }

  &-thumb {
    @apply rounded;
    background-color: #ef575d;
  }
  }
 }

 &.suggestion-item {
  @apply mt-1 mb-1 font-medium text-gray-100
 }
}
</style>
